<template>
    <van-popup v-model:show="show" round position="bottom" :style="{
        minWidth: '100%',
        background: 'transparent',
        zIndex: '10002',
    }">
        <div class="popupContainer">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.ContactService') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close.png" alt="" @click="close">
                </van-col>
            </van-row>
            <div class="serviceCard" v-for="(item, index) in dataSet?.serviceList" :key="index">
                <van-row>
                    <van-col span="4" class="avatarImage">
                        <img :src="item.avatar" alt="">
                    </van-col>
                    <van-col span="12" class="serviceTitle">{{ item.nickname }}</van-col>
                    <van-col span="8" style="display: flex; align-items: center; justify-content: right;">
                        <div class="chat_btn" @click="goToUrl(item.redirectUrl)">{{ $t('profile.chat') }}</div>
                    </van-col>
                </van-row>
                <van-field v-model="item.contactAccount" clearable left-icon="chat" readonly placeholder="" />
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ContactServiceData, goToUrl } from '@/view/profile/supportScript';
import { ref, defineProps, defineEmits, defineExpose, computed } from 'vue'


const props = defineProps<{
    dataSet?: ContactServiceData
}>()

const emits = defineEmits(['open', 'close', 'update:show'])

const show = computed({
    get: () => props.dataSet?.show,
    set: (val) => emits('update:show', val)
})
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}

defineExpose({
    open,
    close
})

</script>
<style scoped>
.van-popup {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(25px) !important;
    padding-bottom: 100px;
}

.title {
    padding: 10px 25px;
    font-size: 14px;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
    background: #4c422499;
    margin-bottom: 15px;
}

.title img {
    width: 25px;
}

.van-overlay {
    z-index: 10001 !important;
    backdrop-filter: blur(5px);
}


.scrollable-content {
    /* flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; */
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.chat_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 10px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
}

.serviceCard {
    background: #3d2e22a6;
    border: 0.5px solid rgba(221, 122, 51, 0.25);
    padding: 15px 30px;
    border-radius: 10px;
    margin: 10px 25px;
    border-radius: 5px;
}

.avatarImage img {
    width: 40px;
}

.serviceTitle {
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;

}

.serviceCard>>>.van-cell {
    padding: 5px 15px;
    margin: 10px 0;
    background: #ffffff29;
    color: #ffffff7a;
    font-size: 15px;
}

.serviceCard>>>.van-field__control {
    color: #ffffff7a;
    font-size: 15px;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
}
</style>